import type { SectorAdmin } from "./useSectorPermissions";

const firstNameOf = (name: string) => name.split(/\s+/)[0];

const comparable = (value: string) => value.toLocaleLowerCase("pt-BR");

/**
 * Nomes dos administradores como o protótipo mostra (`adminFirstNames()` do
 * Atendimento.dc.html): "Ana, Bruno". Dois admins com o mesmo primeiro nome
 * vão com o nome completo, senão quem lê não sabe a quem pedir. Sem nenhum
 * nome, devolve vazio (a linha some).
 */
export function formatAdminFirstNames(admins: readonly SectorAdmin[]): string {
  const names = admins
    .map((admin) => (admin.name ?? "").trim())
    .filter((name) => name.length > 0);

  const countByFirstName = new Map<string, number>();
  for (const name of names) {
    const key = comparable(firstNameOf(name));
    countByFirstName.set(key, (countByFirstName.get(key) ?? 0) + 1);
  }

  return names
    .map((name) => {
      const firstName = firstNameOf(name);
      const isAmbiguous =
        (countByFirstName.get(comparable(firstName)) ?? 0) > 1;
      return isAmbiguous ? name : firstName;
    })
    .join(", ");
}
